import { Injectable } from '@angular/core';
import { DataService } from '../data/data.service';
import { HttpService } from '../http/http.service';
import { getApiUrlForParams, UNLINK_PLAN_API_URL } from '../../utils/api.util';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LinkUnlinkService {
  constructor(private data: DataService, private http: HttpService) { }

  unlinkPlan(contractNumber: string): Observable<string> {
    const auth0Id = this.data.auth0UserId.getValue();
    return this.http.delete<string>(getApiUrlForParams(UNLINK_PLAN_API_URL, { auth0Id, contractNumber }));
  }
}